$(() => {
  const trigger = $('.popover-component');
  const popover = $('.popover');
  trigger.on('click', () => popover.toggleClass('hidden'));
  trigger.on('mouseover', () => popover.toggleClass('hidden'));
});


// WEBPACK FOOTER //
// ./app/components/popover/component.js